import { Spin } from 'antd'
import React from 'react'
import styled from 'styled-components'

type Props = { paddingTop?: string }
export const Fetcher: React.FC<Props> = ({ paddingTop = '' }) => (
  <LoaderWrapper $paddingTop={paddingTop}>
    <Spin size="large" />
  </LoaderWrapper>
)

const LoaderWrapper = styled.div<{ $paddingTop?: string }>`
  padding-top: ${({ $paddingTop }) => ($paddingTop ? $paddingTop : '0')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 99;
`
